import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  timerContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonsPanel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    gap: theme.spacing(2),
  },
  circularTimerContainer: {
    marginTop: theme.spacing(3),
    width: '180px',
    height: '180px',
    position: 'relative',
  },
  circularTimerSvgContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  timerValueContainer: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
